import React from "react";
import "./StudentBanner.css";
import  banner from "./Animated.gif"

const StudentBanner = () => {
  return (
    <div className="upskld_student_banner_pg_wrapper">
      <img
        src={banner}
        alt="Upskld student feedback"
        className="upskld_student_banner_pg_gif"
      />
    </div>
  );
};

export default StudentBanner;